import React, { useState } from "react";
import AdjustmentList from "./AdjustmentList";
import CreateAdjustment from "./CreateAdjustment";
import ViewAdjustment from "./ViewAdjustment";
import { fetchAdjustmentById } from "../../services/adjustment/adjustment";

export default function AdjustmentManagement() {
    const [isCreating, setIsCreating] = useState(false);
    const [activeRecord, setActiveRecord] = useState(null);

    const onlyFormVisible = isCreating || !!activeRecord;

    const closeForm = () => {
        setIsCreating(false);
        setActiveRecord(null);
    };

    return (
        <div className="card shadow-lg main-card">
            <div className="card-header bg-secondary text-white d-flex justify-content-between align-items-center">
                <h4 className="mb-0 h6 fw-semibold">
                    {!onlyFormVisible
                        ? "Adjustments"
                        : isCreating
                            ? "Create Adjustment"
                            : "View Adjustment"}
                </h4>
            </div>

            {onlyFormVisible && (
                <nav
                    aria-label="breadcrumb"
                    className="px-3 py-2 border-bottom bg-light"
                >
                    <ol
                        className="breadcrumb mb-0 align-items-center"
                        style={{ "--bs-breadcrumb-divider": "'/'" }}
                    >
                        <li className="breadcrumb-item">
                            <button
                                type="button"
                                className="btn btn-link p-0 text-decoration-none text-muted"
                                onClick={closeForm}
                            >
                                Adjustments
                            </button>
                        </li>
                        <li
                            className="breadcrumb-item active fw-semibold text-primary"
                            aria-current="page"
                        >
                            {isCreating
                                ? "Create Adjustment"
                                : "View Adjustment"}
                        </li>
                    </ol>
                </nav>
            )}

            <div className="card-body">
                {!onlyFormVisible ? (
                    <AdjustmentList
                        onCreateClick={() => setIsCreating(true)}
                        onView={async (id) => {
                            const apiData = await fetchAdjustmentById(id);
                            setActiveRecord({
                                mode: "view",
                                data: apiData,
                            });
                        }}
                    />
                ) : isCreating ? (
                    <CreateAdjustment
                        onCancel={closeForm}
                        onSubmit={closeForm}
                    />
                ) : (
                    <ViewAdjustment
                        initialValues={activeRecord?.data || {}}
                        onCancel={closeForm}
                    />
                )}
            </div>
        </div>
    );
}
